import VXEStore from './store';
export const validators = new VXEStore();
Object.assign(validators, { _name: 'Validators' });
